exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form_divider[data-v-06565925] {\n  display: block;\n  height: 1px;\n  width: 100%;\n  border-bottom: solid 1px #d0d0d0;\n  margin: 15px 0 30px;\n}", ""]);

// exports
